<template>
    <div class="ah-page user-edit-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <el-button type="dark-transparent" icon="el-icon-arrow-left" @click="$router.push({ name: 'staff' })">回列表</el-button>
                        <h1 style="vertical-align: middle; margin-left: 15px;">帳號編輯</h1>
                    </div>
                    <div class="actions">
                        <el-button v-if="form.onf === 1" @click="onOpenDeactivateDialog" type="danger" icon="el-icon-circle-close">停用</el-button>
                        <el-button v-else @click="onOpenActivateDialog">啟用</el-button>
                        <el-button
                            icon="el-icon-check"
                            class="primary-btn"
                            @click="submitForm"
                            :loading="isSubmitting"
                            :disabled="!form.sno && form.typ === 1 && accountUsedNum >= accountMaxNum"
                        >
                            <span v-if="form.sno">儲存</span>
                            <span v-if="!form.sno">新增</span>
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-form ref="form" :model="form" :rules="rules" label-width="180px" label-position="right">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">帳號資訊</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="帳號類型" prop="typ">
                            <el-radio-group v-model="form.typ" class="radio-option-cards" @change="onTypChange">
                                <el-radio :label="1" border style="width: 200px; padding-bottom: 20px">
                                    <div class="icon"><i class="el-icon-s-custom"></i></div>
                                    <div class="title">Sokuji帳號</div>
                                    <div><span class="icon-label">可登入</span></div>
                                    <div class="intro">可登入、使用系統。</div>
                                </el-radio>
                                <el-radio :label="2" border style="width: 200px; padding-bottom: 20px">
                                    <div class="icon"><i class="el-icon-user"></i></div>
                                    <div class="title">員工收款帳號</div>
                                    <div><span class="icon-label">無法登入</span></div>
                                    <div class="intro">無法登入系統，僅出現在請款單的「付款對象」。</div>
                                </el-radio>
                            </el-radio-group>
                            <!-- <div class="account-amt">可用帳號 {{ accountMaxNum }} 個 / 已啟用帳號 {{ accountUsedNum }} 個</div> -->
                                <el-alert
                                    v-if="!form.sno && form.typ === 1 && accountUsedNum >= accountMaxNum"
                                    type="warning"
                                    style="margin-top: 5px"
                                    center
                                    :closable="false"
                                >員工人數已達您購買方案的上限。如需增加請聯絡客服人員。</el-alert>
                        </el-form-item>
                        <el-form-item v-if="isAhooAccount" v-show="!isDemo || isAdv">
                            <template slot="label"> Sokuji帳號身份 </template>
                            <el-radio-group v-model="form.employee" @change="onChangeEmployee">
                                <el-radio :label="true">員工</el-radio>
                                <el-radio :label="false">非內部員工 <ah-tip>不列入請款單的付款對象（如：公司董事、監察人、執行股東、外部投資人、會計師、財務顧問）</ah-tip></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="帳號 (E-mail)" prop="eml" :rules="isAhooAccount ? rules.eml : []">
                            <div>
                                <el-input
                                    v-model.trim="form.eml"
                                    :disabled="form.iS_OT4 === 1"
                                    class="email-input"
                                    style="max-width: 350px; margin-right: 10px"
                                    placeholder="請輸入可收信的 E-mail 地址"
                                ></el-input>
                                <el-tooltip v-if="isAhooAccount && !isAccountTypChanged" class="item" effect="dark" content="帳號已停用" :manual="!!form.onf" placement="top">
                                    <span>
                                        <el-button type="primary" v-if="$route.params.sno != null" :loading="isSendingEmail" :disabled="isResendEmailDisabled" plain @click="resendEmail">
                                            重發密碼信
                                        </el-button>
                                    </span>
                                </el-tooltip>
                                <span v-if="form.upD_EML_DAT" style="color: #aaa; margin-left: 10px"> 最後編輯：{{ form.upD_EML_DAT | dateFormater("YYYY-MM-dd hh:mm") }} </span>
                            </div>
                            <div v-if="form.iS_OT4 === 1" style="color: #aaa; font-size: 8.5pt;"><i class="el-icon-warning"></i> 此帳號為會計專區授權關聯帳號</div>
                        </el-form-item>
                        <el-form-item label="姓名" prop="nam">
                            <el-input v-model="form.nam" style="max-width: 300px" @change="handleNameChange"></el-input>
                        </el-form-item>
                        <el-form-item prop="abd" label="國籍">
                            <el-radio v-model="form.abd" :label="0" @change="onAbdChanged">本國</el-radio>
                            <el-radio v-model="form.abd" :label="1" @change="onAbdChanged">境外</el-radio>
                        </el-form-item>
                        <el-form-item v-if="form.abd === 1" prop="abD_TYP" label="證件類型">
                            <el-radio v-model="form.abD_TYP" :label="1">護照號碼</el-radio>
                            <el-radio v-model="form.abD_TYP" :label="2">居留證</el-radio>
                        </el-form-item>
                        <el-form-item v-if="form.abd === 0" label="身分證號碼" prop="idNumber" :rules="isDemo ? [] : rules.idNumber">
                            <el-input v-model="form.idNumber" :maxlength="10" :show-word-limit="true" style="max-width: 300px"></el-input>
                        </el-form-item>
                        <el-form-item
                            v-else
                            :label="form.abD_TYP === 1 ? '護照號碼' : '居留證'"
                            prop="idNumber"
                            :rules="isDemo ? [] : { required: true, message: '請輸入居留證／護照號碼', trigger: 'blur' }"
                        >
                            <el-input v-model="form.idNumber" :maxlength="form.abD_TYP === 1 ? 9 : 20" :show-word-limit="true" style="max-width: 300px"></el-input>
                        </el-form-item>
                        <el-form-item v-if="form.employee" label="所屬部門" prop="deP_SNO">
                            <ah-el-select-dep v-model="form.deP_SNO"></ah-el-select-dep>
                            <ah-tip>直接輸入可新增。</ah-tip>
                        </el-form-item>
                        <el-form-item v-if="staffList.length > 0 && form.employee" label="直屬主管" prop="boS_SNO" :rules="staffList.length == 0 ? [{ required: false }] : otherRules.boS_SNO">
                            <template slot="label"> 直屬主管<ah-tip>請款、開發票的主管審核人。</ah-tip> </template>
                            <ah-el-select-staff v-model="form.boS_SNO"></ah-el-select-staff>
                        </el-form-item>
                        <el-form-item prop="mem" label="備註">
                            <el-input v-model="form.mem" type="textarea" :rows="5" style="width: 500px" />
                        </el-form-item>
                        <el-form-item v-if="form.upD_DAT" prop="" label="">
                            <span style="color: #aaa; margin-left: 10px"> 最後編輯：{{ form.upD_DAT | dateFormater("YYYY-MM-dd hh:mm") }} </span>
                        </el-form-item>
                    </div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">
                            薪轉銀行帳戶
                            <ah-tip v-if="form.employee">該帳號申請請款時，付款對象如選擇“公司員工”，則系統自動帶入下方帳戶資料。</ah-tip>
                        </div>
                    </div>
                    <div class="panel-body">
                        <template v-if="form.employee">
                            <el-alert :closable="false" style="margin-bottom: 20px; padding: 3px 5px 5px 5px"> 非必填<span v-if="isAhooAccount">，可由該帳號人員登入後自行輸入。</span> </el-alert>
                            <el-form-item prop="stafF_BNK_BOO" label="銀行">
                                <ah-el-select-bank v-model="form.stafF_BNK_BOO" :branch="form.stafF_BNK_DOO" @branchInput="form.stafF_BNK_DOO = $event" :disabled="false"></ah-el-select-bank>
                            </el-form-item>
                            <el-form-item prop="stafF_BNK_ACC" label="帳號" style="max-width: 800px">
                                <ah-el-input-bank-acc v-model="form.stafF_BNK_ACC" :bankBoo="form.stafF_BNK_BOO"></ah-el-input-bank-acc>
                            </el-form-item>
                            <el-form-item prop="stafF_BNK_TPC" label="戶名">
                                <el-input v-model="form.stafF_BNK_TPC" style="max-width: 300px"></el-input>
                            </el-form-item>
                        </template>
                        <el-alert v-else type="warning" :closable="false" style="padding: 3px 5px 5px 5px">付款資訊，請至委外廠商、委外勞務建立。</el-alert>
                    </div>
                </div>
                <div v-if="isAhooAccount && form.onf" class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">功能設定</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="grP_NO">
                            <template slot="label"> 身份功能 <ahTip>勾選身份預設的功能設定</ahTip> </template>
                            <el-select v-model="form.grP_NO" placeholder="" :disabled="!form.employee" no-data-text="無資料" @change="getInitMenu">
                                <el-option v-for="item in filterdRoleList" :key="item.grP_NO" :label="item.grP_NAM" :value="item.grP_NO" />
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="form.grP_NO" label="功能設定" v-show="!isDemo || isAdv">
                            <ah-authority-table
                                ref="ahAuthorityTable"
                                v-model="form.untList"
                                :preset-unt-list="rolePresetUntList"
                                :disabledList="authDisabledList"
                                style="margin-top: 30px"
                                :show-preset="true"
                            />
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </div>
        <div style="text-align: center">
            <!-- <el-tooltip :disabled="!form.isUsed" effect="dark" content="此帳號已使用，無法刪除" placement="top">
                <span style="margin-right: 10px">
                    <el-button v-if="form.sno" :disabled="form.isUsed" type="danger" icon="el-icon-delete" @click="onDelete">
                        刪除
                    </el-button>
                </span>
            </el-tooltip> -->
            <el-button icon="el-icon-close" @click="$router.push({ name: 'staff' })"> 取消 </el-button>
            <el-button
                icon="el-icon-check"
                type="primary"
                class="primary-btn"
                @click="submitForm"
                style="width: 150px"
                :loading="isSubmitting"
                :disabled="!form.sno && form.typ === 1 && accountUsedNum >= accountMaxNum"
            >
                <span v-if="form.sno">儲存</span>
                <span v-if="!form.sno">新增</span>
            </el-button>
        </div>
        <TrabsferDialog :visible="showTransfer" :subordinateList="subordinateList" :selectMember="transfer" :currentSno="form.sno" @close="saveTransferData" @cancel="cancelDisable" />
        <PasswordDialog :visible="passwordDialog.visible" :sno="passwordDialog.sno" @close="handlePasswordDialogClose" />
        <DeactivateDialog :visible="deactivateDialog.visible" :user-info="form" :subordinateList="subordinateList" @close="onCloseDeactivateDialog" />
    </div>
</template>
<script>
import _ from 'lodash';
import ahTip from '@/components/ui/ahTip.vue';
import ahElSelectBank from '@/components/ui/ahElSelectBank.vue';
import ahElInputBankAcc from '@/components/ui/ahElInputBankAcc.vue';
import ahElSelectDep from '@/components/ui/ahElSelectDep.vue';
import ahElSelectStaff from '@/components/ui/ahElSelectStaff.vue';
import ahAuthorityTable from '@/components/ui/ahAuthorityTable.vue';
import PasswordDialog from '@/components/dashboard/Settings/UserSetting/PasswordDialog.vue';
import DeactivateDialog from '@/components/dashboard/Settings/UserSetting/DeactivateDialog.vue';
import { isNationalIdentificationNumberValid } from 'taiwan-id-validator';
import { mapGetters } from 'vuex';
import TrabsferDialog from './TransferDialog.vue';

export default {
    name: 'UserEditPage',
    components: {
        ahTip,
        ahElSelectBank,
        ahElInputBankAcc,
        TrabsferDialog,
        ahElSelectDep,
        ahElSelectStaff,
        ahAuthorityTable,
        PasswordDialog,
        DeactivateDialog,
    },
    data() {
        const validateBsnId = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入身分證號碼。'));
            } else if (!isNationalIdentificationNumberValid(value)) {
                callback(new Error('身分證號碼格式不正確'));
            } else {
                callback();
            }
        };

        return {
            originalEml: '',
            originalAccountTyp: null,
            showTransfer: false,
            isLoadingDepartments: false,
            isLoadingClient: false,
            isSubmitting: false,
            isSendingEmail: false,
            mode: 'normal', // 一般模式：normal; 簡易模式：easy
            roleList: [],
            staffList: [],
            subordinateList: [],
            rolePresetUntList: [],
            accountMaxNum: 1,
            accountUsedNum: 0,
            form: {
                adm: 0,
                sno: null,
                onf: 0,
                mem: null,
                typ: 1,
                eml: null,
                abd: 0,
                abD_TYP: 0,
                idNumber: null,
                nam: '',
                pJ_NO: null,
                deP_SNO: '',
                boS_DEP_SNO: '',
                boS_SNO: null,
                grP_NO: '',
                untList: [],
                stafF_BNK_BOO: '',
                stafF_BNK_DOO: '',
                stafF_BNK_ACC: '',
                stafF_BNK_TPC: '',
                employee: true,
            },
            transfer: {
                dept: '',
                boss: '',
                name: '',
            },
            rules: {
                eml: [{ required: true, message: '請輸入帳號', trigger: 'blur' }],
                idNumber: [{ required: true, validator: validateBsnId, trigger: 'blur' }],
                nam: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
                deP_SNO: [
                    {
                        required: true,
                        message: '請選擇部門',
                        trigger: 'change',
                    },
                ],
                grP_NO: [
                    {
                        required: true,
                        message: '請選擇身份',
                        trigger: 'change',
                    },
                ],
            },
            otherRules: {
                boS_SNO: [
                    {
                        required: true,
                        message: '請選擇主管',
                        trigger: 'change',
                    },
                ],
            },
            passwordDialog: {
                visible: false,
                sno: null,
            },
            deactivateDialog: {
                visible: false,
            },
        };
    },
    computed: {
        ...mapGetters({
            companyInfo: 'menu/memberInfo',
            isSAAdmin: 'account/isSAAdmin',
        }),
        filterdRoleList() {
            return this.roleList
                .filter((x) => x.grP_NAM !== '帳號管理')
                .filter((x) => x.grP_NAM !== '系統啟用管理')
                .filter((x) => x.grP_NO !== 'Ahoo啟用管理')
                .filter((x) => x.grP_NO !== 'SA')
                .filter((x) => x.grP_NO !== 'ADM')
                .filter((x) => x.grP_NO !== 'INI')
                .filter((x) => (this.isDemo && !this.isAdv ? x.grP_NAM !== '自訂' : x));
        },
        isResendEmailDisabled() {
            if (!this.form.onf) return true;
            return this.originalEml !== this.form.eml;
        },
        isAhooAccount() {
            return this.form.typ === 1;
        },
        isAccountTypChanged() {
            return this.originalAccountTyp !== this.form.typ;
        },
        isDemo() {
            return false;
        },
        isAdv() {
            if (this.isSAAdmin) return true;
            return true;
        },
        authDisabledList() {
            // 檢視者是 SA 全部都能看
            if (this.isSAAdmin) return [];

            // 該編輯對象是「非內部員工帳號」遮蔽功能
            if (!this.form.employee) {
                return [
                    // 基本申請
                    'A01', 'C03', 'B01', 'C02', 'C06',
                    // 專案管理
                    'C01', 'C04', 'C05',
                    // 收付作業
                    'A02', 'A03', 'B02', 'B03',
                    // 審核相關設定
                    'F01', 'F02', 'F22',
                    // 勞報單
                    'H02',
                    // 會計功能
                    'G01', 'G02', 'G06', 'G07', 'G08', 'G09', 'G10', 'G11', 'G12', 'G16',
                ];
            }

            // 該編輯對象「非會計關聯帳號」遮蔽會計功能
            if (this.form.iS_OT4 !== 1) {
                return [
                    // 會計功能
                    'G01', 'G02', 'G06', 'G07', 'G08', 'G09', 'G10', 'G11', 'G12', 'G16',
                ];
            }

            return [];
        },
    },
    async mounted() {
        // 取得身分下拉選單
        this.$api({
            url: '/StaffManagementPage/GetRoleOptions',
            method: 'GET',
        }).then((resp) => {
            this.roleList = resp.data.options;
        });

        this.$api({
            url: '/StaffManagementPage/GetStaffList',
            params: {
                PageSize: 999,
                PageNum: 1,
                TYP: 1,
                ONF: 1,
            },
            method: 'GET',
        }).then((resp) => {
            this.staffList = resp.data.staffs;
            this.accountMaxNum = resp.data.cnt;
            this.accountUsedNum = resp.data.rnt;
        });

        if (this.$route.params.sno) {
            // 取得人員明細
            await this.fetchUserData();
        } else this.form.onf = 1;
    },
    methods: {
        async fetchUserData() {
            const resp = await this.$api({
                url: `/StaffManagementPage/GetStaff?sno=${this.$route.params.sno}`,
                method: 'GET',
            });
            this.form = resp.data.staff;
            this.originalEml = this.form.eml;
            this.selectMember(this.form.boS_DEP_SNO, false);
            this.subordinateList = resp.data.subordinateOptions;
            this.getInitMenu(this.form.grP_NO, false);
            this.form.typ = resp.data.staff.typ;
            this.originalAccountTyp = this.form.typ;

            if (!this.form.employee) {
                this.$nextTick(() => {
                    if (this.checkIsOldExternalEmployeeSettings()) {
                        this.$message({ showClose: true, message: '員工收款帳號功能已更新', type: 'warning' });
                        this.onChangeEmployee(false);
                    }
                });
            }
        },
        checkIsOldExternalEmployeeSettings() {
            const AVALIABLE_LIST = _.chain(this.$refs.ahAuthorityTable.authDisplayList).flatMap('children').map('unt').value();
            const DIFF = _.differenceBy(this.form.untList, AVALIABLE_LIST);
            return !!DIFF.length;
        },
        onChangeEmployee(val) {
            if (!val) {
                const FOUND = _.find(this.filterdRoleList, ['grP_NO', 'ELS']);
                this.form.grP_NO = FOUND.grP_NO;
                this.form.pJ_NO = null;
                this.form.deP_SNO = null;
                this.form.boS_SNO = null;
                this.form.stafF_BNK_BOO = null;
                this.form.stafF_BNK_DOO = null;
                this.form.stafF_BNK_ACC = null;
                this.form.stafF_BNK_TPC = null;

                this.form.untList = [];
                this.$nextTick(() => {
                    this.$refs.ahAuthorityTable.authDisplayList.forEach((group) => {
                        this.$refs.ahAuthorityTable.setAuthByGroup(true, group);
                    });
                });
            }
        },
        goBack() {
            this.$router.push({ name: 'staff', query: { typ: this.form.typ } });
        },
        handleNameChange(nam) {
            if (this.form.stafF_BNK_TPC === '') this.form.stafF_BNK_TPC = nam;
        },
        resendEmail() {
            this.isSendingEmail = true;

            this.$api({
                url: '/StaffManagementPage/SendResetPasswordEmail',
                method: 'POST',
                data: { sno: this.$route.params.sno },
            })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: '認證信已寄出（請稍候檢查信箱）',
                        type: 'success',
                    });
                })
                .finally(() => {
                    this.isSendingEmail = false;
                });
        },
        selectMember(value, refresh = true) {
            if (refresh) this.form.boS_SNO = '';
            if (value) {
                this.$api({
                    url: '/StaffManagementPage/GetManagerOptions',
                    method: 'GET',
                    params: { sno: value },
                }).then((resp) => {
                    this.memberList = resp.data.options;
                });
            }
        },

        handlePasswordDialogClose() {
            this.passwordDialog.visible = false;
            this.passwordDialog.sno = null;
            this.goBack();
        },
        getInitMenu(value, isSetToForm = true) {
            this.$api({
                url: `/StaffManagementPage/GetDefaultUntList?GRP_NO=${value}`,
                method: 'GET',
            }).then((resp) => {
                if (isSetToForm) {
                    let list = JSON.parse(JSON.stringify(resp.data.untList));
                    list = this.getAvailableUntList(list);
                    this.form.untList = list;
                }
                this.rolePresetUntList = resp.data.untList;
            });
        },
        getAvailableUntList(untList) {
            const newList = [];

            untList.forEach((unt) => {
                if (this.isPayed(unt)) newList.push(unt);
            });
            return newList;
        },
        submitForm() {
            // 至少勾一個權限（api）
            if (this.isAhooAccount && this.form.untList.length === 0) {
                this.$message({
                    showClose: true,
                    message: '至少勾選一個功能權限。',
                    type: 'error',
                });
                return;
            }

            // 表單驗證
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    if (this.transfer.boss) await this.transferBoss();
                    await this.upsertStaff();

                    return true;
                }

                this.$message({
                    showClose: true,
                    message: '請修改提示的欄位。',
                    type: 'error',
                });
                return false;
            });
        },
        async onDelete() {
            try {
                this.isSubmitting = true;
                await this.$confirm('確定要刪除此帳號嗎？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.$api({
                    url: '/StaffManagementPage/DeleteStaff',
                    method: 'DELETE',
                    data: { sno: this.form.sno },
                });

                this.$message({
                    showClose: true,
                    message: '帳號已成功刪除',
                    type: 'success',
                });

                this.$router.push({ name: 'staff' });
            } catch (e) {
                console.log(e);
            } finally {
                this.isSubmitting = false;
            }
        },
        async upsertStaff() {
            this.isSubmitting = true;
            const isAdd = !this.form.sno;
            let apiUrl = '';

            try {
                if (!this.form.sno) apiUrl = 'insertStaff';
                else {
                    apiUrl = 'updateStaff';
                    if (this.isAccountTypChanged) {
                        if (this.isAhooAccount) {
                            console.log('一般->Sokuji');
                        } else {
                            console.log('Sokuji->一般');
                            await this.$confirm('確定要改為一般帳號？（此帳號將不再能夠登入Sokuji系統）', {
                                confirmButtonText: '確定',
                                cancelButtonText: '取消',
                            });
                        }
                    }
                }

                const resp = await this.$api({
                    url: `/StaffManagementPage/${apiUrl}`,
                    method: 'POST',
                    data: this.form,
                });
                console.log(resp);

                if (this.isAhooAccount && (isAdd || this.isAccountTypChanged)) {
                    this.passwordDialog.sno = resp.data.sno;
                    this.passwordDialog.visible = true;
                } else {
                    this.$store.dispatch('menu/updateMenu');
                    this.goBack();
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.isSubmitting = false;
            }
        },
        async transferBoss() {
            return this.$api({
                url: '/StaffManagementPage/ChangeManager',
                method: 'POST',
                params: { OldSno: this.form.sno, NewSno: this.transfer.boss },
            });
        },
        handleTransfer(value) {
            if (value) {
                this.transfer = {
                    dept: '',
                    boss: '',
                    name: '',
                };
            }

            if (!value && this.subordinateList.length > 0) {
                this.showTransfer = true;
            }
        },
        saveTransferData(data) {
            if (data) {
                this.transfer = {
                    dept: data.dept,
                    boss: data.boss,
                    name: data.name,
                };

                this.showTransfer = false;
            }
        },
        cancelDisable() {
            this.form.onf = 1;
            this.showTransfer = false;
            this.transfer = {
                dept: '',
                boss: '',
                name: '',
            };
        },
        onTypChange() {
            this.form.employee = true;
        },
        onAbdChanged() {
            this.form.abD_TYP = this.form.abd === 1 ? 1 : 0;
        },
        async onOpenActivateDialog() {
            try {
                await this.$confirm('確定要啟用此使用者？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.$api({
                    url: '/StaffManagementPage/ActiveStaff',
                    method: 'POST',
                    data: { sno: this.form.sno },
                });

                await this.fetchUserData();

                this.$message({
                    showClose: true,
                    message: '帳號已啟用',
                    type: 'success',
                });
            } catch (e) {
                console.log(e);
            }
        },
        onOpenDeactivateDialog() {
            this.deactivateDialog.visible = true;
        },
        onCloseDeactivateDialog() {
            this.deactivateDialog.visible = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.user-edit-page {
    .authority-table {
        .root-item {
            background-color: #f4f4f4;
            padding: 2px 10px;
            border-radius: 5px;
        }

        .group-items {
            margin: 5px 10px 12px 80px;

            .sub-item {
                display: inline-block;
                padding-right: 25px;
            }
        }
    }

    .icon-label {
        display: inline-block;
        padding: 4px 7px 6px 7px;
        margin-bottom: 10px;
        font-size: 8pt;
        font-weight: bold;
        color: #fff;
        background-color: #463cb2;
        border-radius: 5px;
    }
}
</style>
